import styled from '@emotion/styled';

export const GrayImage = styled.div`
	filter: grayscale(100%);
`;
